export default function Footer() {
  return (
    <footer className="border-t border-black/10 bg-white">
      <div className="mx-auto max-w-6xl px-4 py-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div>
          <div className="font-semibold">JW Cyclone Security</div>
          <div className="text-sm text-black/60 mt-1">
            Door Supervisors • Mobile Response • CCTV • Close Protection
          </div>
        </div>

        <div className="text-sm text-black/60">
          © {new Date().getFullYear()} JW Cyclone Security. All rights reserved.
          <span className="text-redAccent"> ●</span>
        </div>
      </div>
    </footer>
  );
}
